export default __webpack_public_path__ + "static/media/Jin_WaterErupt.20368656.png";